export default "__VITE_ASSET__a2f1ed98__"